import { useContext } from "react";
import { ThemeContext } from "../util/ThemeContext";

const Downloads = () => {
  const themeData = useContext(ThemeContext);
  const downloadLinks = themeData?.downloadLinks;
  const availableLinksCount = [
    downloadLinks?.android,
    downloadLinks?.ios,
    downloadLinks?.windows,
  ].filter(Boolean).length;

  return (
    <div
      className="flex h-full justify-center items-center px-4 py-12 bg-cover bg-center relative"
      style={{
        backgroundImage: `url(${themeData?.backgroundImageUrl})`,
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 dark:bg-black/60"></div>

      {/* Content Box */}
      <div className="relative w-full lg:w-4/5 rounded-2xl bg-white/80 dark:bg-gray-900/80 backdrop-blur-md shadow-2xl p-8">
        <div className="max-w-5xl mx-auto">
          {/* Title */}
          <h1 className="text-4xl font-extrabold text-center mb-10 text-blue-700 dark:text-blue-400 drop-shadow-lg">
            Downloads
          </h1>

          {/* Native Apps Section */}
          <h2 className="text-2xl font-semibold text-center mb-6 text-gray-800 dark:text-gray-200">
            Native Apps (Best Experience)
          </h2>

          <div className="grid gap-6 mb-12 grid-cols-1 sm:grid-cols-1 md:grid-cols-3">
            {downloadLinks?.android && (
              <a
                href={downloadLinks?.android}
                className="bg-gradient-to-br from-gray-800 to-black dark:from-gray-700 dark:to-gray-950 p-6 rounded-xl flex flex-col items-center shadow-lg hover:scale-105 transition-transform"
              >
                <img
                  src={"./assets/APK.png"}
                  alt="Android APK"
                  className="h-12 mb-3"
                />
                <span className="text-green-400 font-medium">Android APK</span>
              </a>
            )}

            {downloadLinks?.windows && (
              <a
                href={downloadLinks?.windows}
                className="bg-gradient-to-br from-gray-800 to-black dark:from-gray-700 dark:to-gray-950 p-6 rounded-xl flex flex-col items-center shadow-lg hover:scale-105 transition-transform"
              >
                <img
                  src={"./assets/windows-download-logo1.png"}
                  alt="Windows EXE"
                  className="h-12 mb-3"
                />
                <span className="text-green-400 font-medium">Windows EXE</span>
              </a>
            )}

            {downloadLinks?.ios && (
              <a
                href={downloadLinks?.ios}
                className="bg-gradient-to-br from-gray-800 to-black dark:from-gray-700 dark:to-gray-950 p-6 rounded-xl flex flex-col items-center shadow-lg hover:scale-105 transition-transform"
              >
                <img
                  src={"./assets/ios-download-white.png"}
                  alt="iPhone IPA"
                  className="h-12 mb-3"
                />
                <span className="text-green-400 font-medium">iPhone IPA</span>
              </a>
            )}
          </div>

          {/* Website/Zoom Section */}
          <h2 className="text-2xl font-semibold text-center mb-6 text-gray-800 dark:text-gray-200">
            Website or Zoom App (Alternative Access)
          </h2>

          {/* Responsive Grid for Buttons */}
          <div
            className="
              grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
              gap-4 mb-12 place-items-center
            "
          >
            <a
              href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings"
              className="bg-green-600 hover:bg-green-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
            >
              Android Zoom
            </a>
            <a
              href="https://apps.apple.com/us/app/zoom-one-platform-to-connect/id546505307"
              className="bg-gray-600 hover:bg-gray-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              iPhone Zoom
            </a>
            <a
              href="https://zoom.us/client/latest/ZoomInstaller.exe"
              className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
            >
              Windows Zoom
            </a>
            <a
              href="https://zoom.us/client/latest/Zoom.pkg"
              className="bg-sky-600 hover:bg-sky-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
            >
              Mac Zoom
            </a>
            <a
              href="https://zoom.us/client/latest/zoom_x86_64.tar.xz"
              className="bg-yellow-600 hover:bg-yellow-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
            >
              Linux Zoom
            </a>
            <a
              href="https://zoom.us/download"
              className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-full text-white font-medium shadow-md w-full text-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website (Others)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;

// {
//   /* <a
//               href="#"
//               className="bg-black p-4 rounded-2xl flex flex-col items-center hover:scale-105 transition"
//             >
//               <img
//                 src={"./assets/Google-Play-Store.jpg"}
//                 alt="Google Play"
//                 className="h-10 mb-2"
//               />
//               <span className="text-green-400">Android App</span>
//             </a>
//             <a
//               href="#"
//               className="bg-black p-4 rounded-2xl flex flex-col items-center hover:scale-105 transition"
//             >
//               <img
//                 src={"./assets/ios-download-white.png"}
//                 alt="APK Direct"
//                 className="h-10 mb-2"
//               />
//               <span className="text-green-400">IPhone App</span>
//             </a>
//             <a
//               href="#"
//               className="bg-black p-4 rounded-2xl flex flex-col items-center hover:scale-105 transition"
//             >
//               <img
//                 src={"./assets/android-tv.png"}
//                 alt="Android TV"
//                 className="h-10 mb-2"
//               />
//               <span className="text-green-400">Android TV</span>
//             </a> */
// }
